/**
 * Generate feature toggles object for client group overview components/logic
 * @param {Object} featureDecisions Object returned from `services/features/featureDecisions.js`
 */
const clientGroupOverviewFeatureFactory = (
  featureDecisions,
  enabledForClient = false
) => {
  return {
    canViewDetails: featureDecisions.canViewClientGroupOverview(
      enabledForClient
    ),
  }
}

export default clientGroupOverviewFeatureFactory
